import type { ChangeEvent, InputHTMLAttributes, ReactNode } from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cn } from "../utils/cx.js";

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  children?: ReactNode;
}

export function Switch({ children, className, disabled, checked, defaultChecked, onChange }: SwitchProps) {
  const control = (
    <SwitchPrimitive.Root
      disabled={disabled}
      checked={checked}
      defaultChecked={defaultChecked}
      onCheckedChange={(next) =>
        onChange?.({ target: { checked: next } } as unknown as ChangeEvent<HTMLInputElement>)
      }
      className={cn(
        "peer inline-flex h-5 w-9 shrink-0 items-center rounded-full border border-transparent shadow-xs outline-none transition-colors focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
        children == null && className,
      )}
    >
      <SwitchPrimitive.Thumb className="pointer-events-none block size-4 rounded-full bg-background shadow-sm ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0" />
    </SwitchPrimitive.Root>
  );

  if (children == null) return control;
  return (
    <label
      className={cn(
        "inline-flex items-center gap-2 text-sm",
        disabled && "cursor-not-allowed opacity-50",
        className,
      )}
    >
      {control}
      <span>{children}</span>
    </label>
  );
}
